import { FilterDto, FilterTagItem } from '../../models/Tags';
import api from '../../api/apiService';

const moduleUri = '/common/v1/tags';

let filtersPromise: Promise<FilterDto[]>;
let tagsMapPromise: Promise<Record<string, FilterTagItem>> | null;

export const fetchFilters = (): void => {
  filtersPromise = api.get<FilterDto[]>(`${moduleUri}/filters`).then((response) => {
    return response.data;
  });
  tagsMapPromise = null;
};

export const getFilters = (): Promise<FilterDto[]> => {
  return filtersPromise;
};

export const getFiltersTagsMap = async (): Promise<Record<string, FilterTagItem>> => {
  if (tagsMapPromise) {
    return tagsMapPromise;
  }
  if (!filtersPromise) {
    fetchFilters();
  }
  const filters = await filtersPromise;

  const tagsMap: Record<string, FilterTagItem> = filters.reduce((acc, filter) => {
    const optionsMap = filter.options.reduce<Record<string, FilterTagItem>>(
      (acc, filterItem) => ({
        ...acc,
        [filterItem.tagId]: { tagId: filterItem.tagId, displayName: filterItem.displayName, type: filter.type },
      }),
      {}
    );
    return {
      ...acc,
      ...optionsMap,
    };
  }, {});
  tagsMapPromise = Promise.resolve(tagsMap);
  return tagsMapPromise;
};
